export default __webpack_public_path__ + "static/media/Digital Health Card.d558d4f9.svg";